import { jsxs as x, jsx as i } from "react/jsx-runtime";
import { c as n } from "../../index-Cu0xwYjD.js";
import { forwardRef as L, useRef as M, useId as O, useState as q, useCallback as w, useImperativeHandle as A } from "react";
import { GlobalCSSClass as r, FormElementType as G } from "../../utils/enums.js";
import { getFormControlValueAsString as H } from "../../utils/helpers.form.js";
import "../CheckboxMark/CheckboxMark.types.js";
import { IressCheckboxMark as T } from "../CheckboxMark/CheckboxMark.js";
import { useControlledState as g } from "../../utils/hooks/useControlledState.js";
const z = "ids-checkbox--label-v501", B = "ids-checkbox--mark-v501", D = "ids-checkbox--checked-v501", J = "ids-checkbox--indeterminate-v501", K = "ids-checkbox-v501", Q = "ids-checkbox--focus-v501", U = "ids-checkbox--hidden-control-v501", W = "ids-checkbox--input-v501", X = "ids-checkbox--hidden-label-v501", Y = "ids-checkbox--label-span-v501", e = {
  label: z,
  mark: B,
  checked: D,
  indeterminate: J,
  checkbox: K,
  "ids-checkboxMark": "ids-checkbox-mark-v501",
  focus: Q,
  hiddenControl: U,
  input: W,
  hiddenLabel: X,
  labelSpan: Y
}, Z = ({
  checked: f,
  className: v,
  defaultChecked: C,
  hiddenControl: k,
  hiddenLabel: h,
  indeterminate: m,
  id: I,
  onChange: o,
  value: d,
  children: S,
  ...N
}, y) => {
  const b = M(null), c = b.current, R = O(), u = I || R, [F, V] = q(
    m ?? !1
  ), {
    value: t,
    setValue: a,
    isControlled: s
  } = g({
    component: "IressCheckbox",
    propName: "checked",
    defaultValue: C,
    value: f
  }), p = s ? m : F, j = w(
    (l) => {
      s || V(!1), a(l.target.checked), o == null || o(l, d);
    },
    [s, o, a, d]
  );
  return A(y, () => ({
    // React hook form requires the focus, blur, input
    focus: () => c == null ? void 0 : c.focus(),
    blur: () => c == null ? void 0 : c.blur(),
    input: c,
    check: (l) => {
      a(l);
    },
    reset: () => {
      a(!1);
    }
  })), /* @__PURE__ */ x(
    "div",
    {
      className: n(v, {
        [r.FormElement]: !0,
        [e.checkbox]: !0,
        [e.checked]: t,
        [e.hiddenControl]: k,
        [e.hiddenLabel]: h,
        [e.indeterminate]: p
      }),
      children: [
        /* @__PURE__ */ i(
          "input",
          {
            ...N,
            value: H(d),
            type: G.Checkbox,
            id: u,
            defaultChecked: s ? void 0 : t,
            checked: s ? t : void 0,
            className: n(e.input, r.SROnly),
            onChange: j,
            ref: b
          }
        ),
        /* @__PURE__ */ x(
          "label",
          {
            htmlFor: u,
            className: n({
              [e.label]: !0
            }),
            children: [
              !k && /* @__PURE__ */ i(
                T,
                {
                  className: e.mark,
                  checked: t,
                  indeterminate: p
                }
              ),
              /* @__PURE__ */ i(
                "span",
                {
                  className: n(e.labelSpan, {
                    [r.SROnly]: h
                  }),
                  children: S
                }
              )
            ]
          }
        )
      ]
    }
  );
}, _ = L(
  Z
);
_.displayName = "IressCheckbox";
export {
  _ as IressCheckbox
};
